import axios from "axios";
import { ContactCreateInterface, ContactUpdateInterface } from "./contact.type"

// Add customer contact
async function postCustomerContactApi(uuid: string, clientUuid: string, data: ContactCreateInterface) {
    return axios({
        method: 'POST',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/contacts`,
        data: data
    });
}

// Get all customer's contacts
async function getCustomerContactApi(uuid: string, clientUuid: string) {
    return axios({
        method: 'GET',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/contacts`
    });
}

// Patch client addresses
async function patchCustomerContactApi(uuid: string, clientUuid: string, contactUuid: string, data: ContactUpdateInterface) {
    return axios({
        method: 'PATCH',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/contacts/${contactUuid}`,
        data: data
    });
}

// Delete client addresses
async function deleteCustomerContactApi(uuid: string, clientUuid: string, contactUuid: string) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/contacts/${contactUuid}`
    });
}

export {
    deleteCustomerContactApi,
    getCustomerContactApi,
    patchCustomerContactApi,
    postCustomerContactApi
}